/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusUploadIdsDto } from '../../models/lexplus-upload-ids-dto';

export interface UploadsControllerBulkDeleteV1$Params {
      body: LexplusUploadIdsDto
}

export function uploadsControllerBulkDeleteV1(http: HttpClient, rootUrl: string, params: UploadsControllerBulkDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerBulkDeleteV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

uploadsControllerBulkDeleteV1.PATH = '/v1/uploads/bulk-delete';
